import React from 'react';
import { SparklesIcon, CompassIcon } from 'lucide-react';
import { storyGalaxyData } from '../../data/storyGalaxyData';
import { MoodClusterCard } from './components/MoodClusterCard';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { usePlatform } from '../../context/PlatformContext';
const StoryGalaxy = () => {
  const dk = useDarkClasses();
  const {
    isAfterTide
  } = usePlatform();
  return <div className={`min-h-screen ${dk.page} pb-20`} data-id="element-14128" data-mp="3o4hx01hdw9c">
      {/* Header */}
      <div className={`relative overflow-hidden border-b ${dk.border} ${dk.isDark ? 'bg-gray-900' : 'bg-slate-900'}`} data-id="element-14129" data-mp="8nz9z6wzsrvz">
        {/* Background effects */}
        <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)',
        backgroundSize: '32px 32px'
      }} data-id="element-14130" data-mp="dl99xgi0cly2" />
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl" data-id="element-14131" data-mp="2kel64h2fy0ap" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl" data-id="element-14132" data-mp="3nmf2uefiuthr" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 text-center" data-id="element-14133" data-mp="3isjapslxw0ui">
          <div className="inline-flex items-center justify-center p-3 rounded-2xl bg-white/10 backdrop-blur-md mb-6 border border-white/10" data-id="element-14134" data-mp="3dvkijflu63yy">
            <CompassIcon className="h-8 w-8 text-indigo-300" data-id="element-14135" data-mp="ae29j4ubuqwy" />
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white tracking-tight mb-6" data-id="element-14136" data-mp="aby7ksfzo1zb">
            The Story Galaxy
          </h1>
          <p className="text-lg sm:text-xl text-indigo-100/80 max-w-2xl mx-auto leading-relaxed" data-id="element-14137" data-mp="f3amdzd69n5">
            Discover your next obsession by exploring mood clusters and genre
            constellations. Find the perfect combination of tropes, tones, and
            worlds.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-14138" data-mp="2h6uzhlyh35be">
        <div className="flex items-center gap-3 mb-8" data-id="element-14139" data-mp="2imgssutsxykw">
          <SparklesIcon className={`h-6 w-6 ${isAfterTide ? 'text-[#e2b04a]' : 'text-indigo-500'}`} data-id="element-14140" data-mp="2nlk0kn162iwk" />
          <h2 className={`text-2xl font-bold ${dk.textHeading}`} data-id="element-14141" data-mp="28mq110wmlxoi">
            Explore Mood Clusters
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-14142" data-mp="2dkzwzdq6d2b6">
          {storyGalaxyData.moodClusters.map(cluster => <MoodClusterCard key={cluster.id} cluster={cluster} data-id="element-14143" data-mp="24mo9hkklukmy" />)}
        </div>
      </div>
    </div>;
};
export default StoryGalaxy;